import {Component, OnInit, AfterViewInit, Output, EventEmitter} from '@angular/core';
import {Router} from "@angular/router";
import {TokenUnlockService} from "../../lib/services/token-unlock/token-unlock.service";
import {ToastService} from "../../lib/services/toast/toast.service";
import {AuthenticationService} from "../../lib/services/autenticacion/authentication.service";
import {UserBlockedService} from "../../lib/services/user-blocked/user-blocked-service.service";
import {TokenUnlockedSuccessService} from "../../lib/services/token-unlocked-success/token-unlocked-success.service";
import { firstValueFrom } from 'rxjs';
import { ModalsService } from '../../lib/services/modals/modals.service';

@Component({
  selector: 'lib-token-unlock',
  templateUrl: './token-unlock.component.html',
  styleUrls: ['./token-unlock.component.scss']
})
export class TokenUnlockComponent implements AfterViewInit {

  modalMessage = ''
  codeSent = true;
  validCode = false;
  codeIntroduced: string = ""
  errorCodeIntroduced: boolean = false;
  validating: boolean = false;
  resending: boolean = false
  title: string = ""
  paragraph: string = ""
  sendRegularCode: boolean = true
  translations: any
  // @Output() tokenBlockedError: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
    public tokenUnlockService: TokenUnlockService,
    private toastService: ToastService,
    private router: Router,
    private tokenUnlockedSuccessService: TokenUnlockedSuccessService,
    private authenticationService: AuthenticationService,
    private userBlockedService: UserBlockedService,
    private modalService: ModalsService
    ) {
  }

  closeModal() {
    this.tokenUnlockService.close()
  }

  onCodeCompleted(event: any) {
    this.validCode = true;
    this.codeIntroduced = event
  }

  onCodeChanged(event: any) {
    this.errorCodeIntroduced = false
    if(!event || event.length < 6){
      this.validCode = false;
    }
  }

  async resendCodeEmail() {
    let res

    if (!this.sendRegularCode) {
      this.resending = true
      try {
        res = await firstValueFrom(this.authenticationService.sendEmailToCloseSession(this.authenticationService.getAuthCloseSessionHeaders()))
      } catch (error: any) {
        this.resending = false
        if (error.error.errorCode == "AUTH_SESSION_03") {
          this.toastService.showToast(this.translations["AUTH_SESSION_03"], "error", "Error", "tk")
          return
        }

        if (error.error.errorCode == "TOKEN01") {
          this.toastService.showToast(this.translations["TOKEN01"], "error", "Error", "tk")
          return
        }

        this.toastService.showToast(this.translations["EMAIL_CLOSE_SESSION_ERROR"], "error", "Error", "tk")
        return
      }
      this.resending = false
      return res
    }
    this.resending = true
    await this.tokenUnlockService.sentEmailCode(false)
    this.resending = false
  }

  async validateCode() {
    this.validating = true;
    if (!(this.codeIntroduced !== '' && this.codeIntroduced !== null && this.codeIntroduced.length >= 6)) {
      this.validating = false
      this.toastService.showToast(this.translations.CODE_ERROR, "error", "Error code", "tk")
      return
    }
    if (!this.sendRegularCode) {
      await this.validatingCloseSessionCode()
      this.validating = false
      return
    }
    await this.validatingCode()
    this.validating = false
  }

  async validatingCode() {
    let res

    try {
      res = await firstValueFrom(this.tokenUnlockService.validateCode(this.codeIntroduced))
    } catch (err: any) {
      this.validating = false;

      if (err.error.errorCode == "USR05") {
        console.log(err)
        this.toastService.showToast(err.error.errorDescription, "error", "Error")
        return;
      } else if(err.error.errorCode == "USR04") {
        console.log(err)
        this.errorCodeIntroduced = true
        return;
      } else if (err.error.errorCode == "USR03") {
        console.log(err)
        this.tokenUnlockService.close()
        this.tokenUnlockService.tokenBlockError = true
        return
      }
    }

    this.toastService.showToast(this.translations.OP_SUCCESS, "success", "Success")
    this.closeModal();
    this.tokenUnlockedSuccessService.open()
    this.validating = false;
  }

  async validatingCloseSessionCode() {
    let res

    try {
      res = await firstValueFrom(this.authenticationService.validateCodeCloseSession(this.authenticationService.getAuthCloseSessionHeaders(), this.codeIntroduced))
    } catch (error: any) {
      console.log(error)
      if (error.error.errorCode == "AUTH02") {
        this.tokenUnlockService.close()
        this.userBlockedService.open(this.userBlockedService.getTranslations())
        this.toastService.showToast(this.translations.USER_BLOCKED, "error", "Error", "tk")
        return
      }

      if (error.error.errorCode == "AUHT08") {
        this.toastService.showToast(this.translations.INVALID_TOKEN, "error", "Error", "tk")
        return
      }

      this.toastService.showToast(this.translations.TOKEN_INVALID_ERROR, "error", "Error", "tk")
      return
    }
    this.closeModal()
    this.modalService.open([], "success", true, true, this.translations.MODAL_TITLE, undefined, 'sm')
  }

  ngAfterViewInit(): void {
      setTimeout(() => {
        this.codeSent = false
      }, 3000)
  }
}
